"use client";
// РУКА 2 (по Р-020). Кнопка меню на телефоне — как в макете: открывает и закрывает строку разделов (.hd3 → .mopen).
import { Suspense, useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { Icon } from "./icons";

const STYLE = { background: "#0E488F", borderColor: "#13519B", color: "#fff" };

// Адрес страницы известен только при запросе — без Suspense страница не собирается заранее (cacheComponents).
// Пока адрес не пришёл — та же кнопка, нажимать ещё нечего.
export function Burger() {
  return (
    <Suspense
      fallback={
        <button type="button" className="ic burger" style={STYLE} aria-label="Меню" disabled>
          <Icon name="menu" />
        </button>
      }
    >
      <BurgerLive />
    </Suspense>
  );
}

function BurgerLive() {
  // открыто «на этой странице»: перешли на другую — меню само закрыто
  const path = usePathname();
  const [openAt, setOpenAt] = useState<string | null>(null);
  const open = openAt === path;
  useEffect(() => {
    document.getElementById("site-nav")?.classList.toggle("mopen", open);
  }, [open]);
  return (
    <button
      type="button"
      className="ic burger"
      style={STYLE}
      aria-label="Меню"
      aria-expanded={open}
      aria-controls="site-nav"
      onClick={() => setOpenAt(open ? null : path)}
    >
      <Icon name="menu" />
    </button>
  );
}
